import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Switch = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_10962_94683)">
            <rect
              x="0.5"
              y="4"
              width="19.9875"
              height="12"
              rx="1"
              fill="url(#switch_paint0_linear_10962_94683)"
            />
            <rect
              x="0.5"
              y="4"
              width="19.9875"
              height="12"
              rx="1"
              fill="url(#switch_paint1_linear_10962_94683)"
              fill-opacity="0.5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.34961 11.0713H5.54961V13.6048H5.01468V14.2053H2.88428V13.6048H2.34961V11.0713Z"
              fill="url(#switch_paint2_linear_10962_94683)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.34961 11.0713H5.54961V13.6048H5.01468V14.2053H2.88428V13.6048H2.34961V11.0713Z"
              fill="url(#switch_paint3_linear_10962_94683)"
              fill-opacity="0.4"
            />
            <path
              d="M5.54961 11.0713H5.64961C5.64961 11.0161 5.60484 10.9713 5.54961 10.9713V11.0713ZM2.34961 11.0713V10.9713C2.29438 10.9713 2.24961 11.0161 2.24961 11.0713H2.34961ZM5.54961 13.6048V13.7048C5.60484 13.7048 5.64961 13.66 5.64961 13.6048H5.54961ZM5.01468 13.6048V13.5048C4.95945 13.5048 4.91468 13.5496 4.91468 13.6048H5.01468ZM5.01468 14.2053V14.3053C5.06991 14.3053 5.11468 14.2605 5.11468 14.2053H5.01468ZM2.88428 14.2053H2.78428C2.78428 14.2605 2.82905 14.3053 2.88428 14.3053V14.2053ZM2.88428 13.6048H2.98428C2.98428 13.5496 2.93951 13.5048 2.88428 13.5048V13.6048ZM2.34961 13.6048H2.24961C2.24961 13.66 2.29438 13.7048 2.34961 13.7048V13.6048ZM5.54961 10.9713H2.34961V11.1713H5.54961V10.9713ZM5.64961 13.6048V11.0713H5.44961V13.6048H5.64961ZM5.01468 13.7048H5.54961V13.5048H5.01468V13.7048ZM5.11468 14.2053V13.6048H4.91468V14.2053H5.11468ZM2.88428 14.3053H5.01468V14.1053H2.88428V14.3053ZM2.78428 13.6048V14.2053H2.98428V13.6048H2.78428ZM2.34961 13.7048H2.88428V13.5048H2.34961V13.7048ZM2.24961 11.0713V13.6048H2.44961V11.0713H2.24961Z"
              fill="url(#switch_paint4_linear_10962_94683)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.38257 11.0713H9.58257V13.6048H9.04764V14.2053H6.91724V13.6048H6.38257V11.0713Z"
              fill="#3A393C"
            />
            <path
              d="M9.58257 11.0713H9.68257C9.68257 11.0161 9.6378 10.9713 9.58257 10.9713V11.0713ZM6.38257 11.0713V10.9713C6.32734 10.9713 6.28257 11.0161 6.28257 11.0713H6.38257ZM9.58257 13.6048V13.7048C9.6378 13.7048 9.68257 13.66 9.68257 13.6048H9.58257ZM9.04764 13.6048V13.5048C8.99241 13.5048 8.94764 13.5496 8.94764 13.6048H9.04764ZM9.04764 14.2053V14.3053C9.10286 14.3053 9.14764 14.2605 9.14764 14.2053H9.04764ZM6.91724 14.2053H6.81724C6.81724 14.2605 6.86201 14.3053 6.91724 14.3053V14.2053ZM6.91724 13.6048H7.01724C7.01724 13.5496 6.97246 13.5048 6.91724 13.5048V13.6048ZM6.38257 13.6048H6.28257C6.28257 13.66 6.32734 13.7048 6.38257 13.7048V13.6048ZM9.58257 10.9713H6.38257V11.1713H9.58257V10.9713ZM9.68257 13.6048V11.0713H9.48257V13.6048H9.68257ZM9.04764 13.7048H9.58257V13.5048H9.04764V13.7048ZM9.14764 14.2053V13.6048H8.94764V14.2053H9.14764ZM6.91724 14.3053H9.04764V14.1053H6.91724V14.3053ZM6.81724 13.6048V14.2053H7.01724V13.6048H6.81724ZM6.38257 13.7048H6.91724V13.5048H6.38257V13.7048ZM6.28257 11.0713V13.6048H6.48257V11.0713H6.28257Z"
              fill="url(#switch_paint5_linear_10962_94683)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0137 11.0713H19.2137V13.6048H18.6787V14.2053H16.5483V13.6048H16.0137V11.0713Z"
              fill="#363538"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0137 11.0713H19.2137V13.6048H18.6787V14.2053H16.5483V13.6048H16.0137V11.0713Z"
              fill="url(#switch_paint6_linear_10962_94683)"
              fill-opacity="0.2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0137 11.0713H19.2137V13.6048H18.6787V14.2053H16.5483V13.6048H16.0137V11.0713Z"
              fill="url(#switch_paint7_linear_10962_94683)"
              fill-opacity="0.4"
            />
            <path
              d="M19.2137 11.0713H19.3137C19.3137 11.0161 19.2689 10.9713 19.2137 10.9713V11.0713ZM16.0137 11.0713V10.9713C15.9584 10.9713 15.9137 11.0161 15.9137 11.0713H16.0137ZM19.2137 13.6048V13.7048C19.2689 13.7048 19.3137 13.66 19.3137 13.6048H19.2137ZM18.6787 13.6048V13.5048C18.6235 13.5048 18.5787 13.5496 18.5787 13.6048H18.6787ZM18.6787 14.2053V14.3053C18.734 14.3053 18.7787 14.2605 18.7787 14.2053H18.6787ZM16.5483 14.2053H16.4483C16.4483 14.2605 16.4931 14.3053 16.5483 14.3053V14.2053ZM16.5483 13.6048H16.6483C16.6483 13.5496 16.6036 13.5048 16.5483 13.5048V13.6048ZM16.0137 13.6048H15.9137C15.9137 13.66 15.9584 13.7048 16.0137 13.7048V13.6048ZM19.2137 10.9713H16.0137V11.1713H19.2137V10.9713ZM19.3137 13.6048V11.0713H19.1137V13.6048H19.3137ZM18.6787 13.7048H19.2137V13.5048H18.6787V13.7048ZM18.7787 14.2053V13.6048H18.5787V14.2053H18.7787ZM16.5483 14.3053H18.6787V14.1053H16.5483V14.3053ZM16.4483 13.6048V14.2053H16.6483V13.6048H16.4483ZM16.0137 13.7048H16.5483V13.5048H16.0137V13.7048ZM15.9137 11.0713V13.6048H16.1137V11.0713H15.9137Z"
              fill="url(#switch_paint8_linear_10962_94683)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.38257 6.64746H9.58257V9.18096H9.04764V9.78146H6.91724V9.18096H6.38257V6.64746Z"
              fill="#363538"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.38257 6.64746H9.58257V9.18096H9.04764V9.78146H6.91724V9.18096H6.38257V6.64746Z"
              fill="url(#switch_paint9_linear_10962_94683)"
              fill-opacity="0.2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.38257 6.64746H9.58257V9.18096H9.04764V9.78146H6.91724V9.18096H6.38257V6.64746Z"
              fill="url(#switch_paint10_linear_10962_94683)"
              fill-opacity="0.4"
            />
            <path
              d="M9.58257 6.64746H9.68257C9.68257 6.59223 9.6378 6.54746 9.58257 6.54746V6.64746ZM6.38257 6.64746V6.54746C6.32734 6.54746 6.28257 6.59223 6.28257 6.64746H6.38257ZM9.58257 9.18096V9.28096C9.6378 9.28096 9.68257 9.23619 9.68257 9.18096H9.58257ZM9.04764 9.18096V9.08096C8.99241 9.08096 8.94764 9.12574 8.94764 9.18096H9.04764ZM9.04764 9.78146V9.88146C9.10286 9.88146 9.14764 9.83668 9.14764 9.78146H9.04764ZM6.91724 9.78146H6.81724C6.81724 9.83668 6.86201 9.88146 6.91724 9.88146V9.78146ZM6.91724 9.18096H7.01724C7.01724 9.12574 6.97246 9.08096 6.91724 9.08096V9.18096ZM6.38257 9.18096H6.28257C6.28257 9.23619 6.32734 9.28096 6.38257 9.28096V9.18096ZM9.58257 6.54746H6.38257V6.74746H9.58257V6.54746ZM9.68257 9.18096V6.64746H9.48257V9.18096H9.68257ZM9.04764 9.28096H9.58257V9.08096H9.04764V9.28096ZM9.14764 9.78146V9.18096H8.94764V9.78146H9.14764ZM6.91724 9.88146H9.04764V9.68146H6.91724V9.88146ZM6.81724 9.18096V9.78146H7.01724V9.18096H6.81724ZM6.38257 9.28096H6.91724V9.08096H6.38257V9.28096ZM6.28257 6.64746V9.18096H6.48257V6.64746H6.28257Z"
              fill="url(#switch_paint11_linear_10962_94683)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0137 6.64746H19.2137V9.18096H18.6787V9.78146H16.5483V9.18096H16.0137V6.64746Z"
              fill="#363538"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0137 6.64746H19.2137V9.18096H18.6787V9.78146H16.5483V9.18096H16.0137V6.64746Z"
              fill="url(#switch_paint12_linear_10962_94683)"
              fill-opacity="0.2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.0137 6.64746H19.2137V9.18096H18.6787V9.78146H16.5483V9.18096H16.0137V6.64746Z"
              fill="url(#switch_paint13_linear_10962_94683)"
              fill-opacity="0.4"
            />
            <path
              d="M19.2137 6.64746H19.3137C19.3137 6.59223 19.2689 6.54746 19.2137 6.54746V6.64746ZM16.0137 6.64746V6.54746C15.9584 6.54746 15.9137 6.59223 15.9137 6.64746H16.0137ZM19.2137 9.18096V9.28096C19.2689 9.28096 19.3137 9.23619 19.3137 9.18096H19.2137ZM18.6787 9.18096V9.08096C18.6235 9.08096 18.5787 9.12574 18.5787 9.18096H18.6787ZM18.6787 9.78146V9.88146C18.734 9.88146 18.7787 9.83668 18.7787 9.78146H18.6787ZM16.5483 9.78146H16.4483C16.4483 9.83668 16.4931 9.88146 16.5483 9.88146V9.78146ZM16.5483 9.18096H16.6483C16.6483 9.12574 16.6036 9.08096 16.5483 9.08096V9.18096ZM16.0137 9.18096H15.9137C15.9137 9.23619 15.9584 9.28096 16.0137 9.28096V9.18096ZM19.2137 6.54746H16.0137V6.74746H19.2137V6.54746ZM19.3137 9.18096V6.64746H19.1137V9.18096H19.3137ZM18.6787 9.28096H19.2137V9.08096H18.6787V9.28096ZM18.7787 9.78146V9.18096H18.5787V9.78146H18.7787ZM16.5483 9.88146H18.6787V9.68146H16.5483V9.88146ZM16.4483 9.18096V9.78146H16.6483V9.18096H16.4483ZM16.0137 9.28096H16.5483V9.08096H16.0137V9.28096ZM15.9137 6.64746V9.18096H16.1137V6.64746H15.9137Z"
              fill="url(#switch_paint14_linear_10962_94683)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.34937 6.64746H5.54937V9.18096H5.01443V9.78146H2.88403V9.18096H2.34937V6.64746Z"
              fill="#363538"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.34937 6.64746H5.54937V9.18096H5.01443V9.78146H2.88403V9.18096H2.34937V6.64746Z"
              fill="url(#switch_paint15_linear_10962_94683)"
              fill-opacity="0.2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.34937 6.64746H5.54937V9.18096H5.01443V9.78146H2.88403V9.18096H2.34937V6.64746Z"
              fill="url(#switch_paint16_linear_10962_94683)"
              fill-opacity="0.4"
            />
            <path
              d="M5.54937 6.64746H5.64937C5.64937 6.59223 5.60459 6.54746 5.54937 6.54746V6.64746ZM2.34937 6.64746V6.54746C2.29414 6.54746 2.24937 6.59223 2.24937 6.64746H2.34937ZM5.54937 9.18096V9.28096C5.60459 9.28096 5.64937 9.23619 5.64937 9.18096H5.54937ZM5.01443 9.18096V9.08096C4.9592 9.08096 4.91443 9.12574 4.91443 9.18096H5.01443ZM5.01443 9.78146V9.88146C5.06966 9.88146 5.11443 9.83668 5.11443 9.78146H5.01443ZM2.88403 9.78146H2.78403C2.78403 9.83668 2.8288 9.88146 2.88403 9.88146V9.78146ZM2.88403 9.18096H2.98403C2.98403 9.12574 2.93926 9.08096 2.88403 9.08096V9.18096ZM2.34937 9.18096H2.24937C2.24937 9.23619 2.29414 9.28096 2.34937 9.28096V9.18096ZM5.54937 6.54746H2.34937V6.74746H5.54937V6.54746ZM5.64937 9.18096V6.64746H5.44937V9.18096H5.64937ZM5.01443 9.28096H5.54937V9.08096H5.01443V9.28096ZM5.11443 9.78146V9.18096H4.91443V9.78146H5.11443ZM2.88403 9.88146H5.01443V9.68146H2.88403V9.88146ZM2.78403 9.18096V9.78146H2.98403V9.18096H2.78403ZM2.34937 9.28096H2.88403V9.08096H2.34937V9.28096ZM2.24937 6.64746V9.18096H2.44937V6.64746H2.24937Z"
              fill="url(#switch_paint17_linear_10962_94683)"
            />
          </g>
          <defs>
            <linearGradient
              id="switch_paint0_linear_10962_94683"
              x1="10.4938"
              y1="4"
              x2="10.4938"
              y2="16.2108"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#373737" />
              <stop offset="0.150552" stop-color="#9F9F9F" />
              <stop offset="0.809196" stop-color="#939393" />
              <stop offset="1" stop-color="#252525" />
            </linearGradient>
            <linearGradient
              id="switch_paint1_linear_10962_94683"
              x1="0.5"
              y1="10"
              x2="20.1586"
              y2="10"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.100213" stop-opacity="0" />
              <stop offset="0.876586" stop-opacity="0" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="switch_paint2_linear_10962_94683"
              x1="3.94961"
              y1="11.0713"
              x2="3.94961"
              y2="14.1846"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#2D5828" />
              <stop offset="0.0829549" stop-color="#73F066" />
              <stop offset="0.869016" stop-color="#64DD57" />
              <stop offset="1" stop-color="#2B5227" />
            </linearGradient>
            <linearGradient
              id="switch_paint3_linear_10962_94683"
              x1="2.34961"
              y1="12.2266"
              x2="5.54961"
              y2="12.2247"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.0835201" stop-opacity="0" />
              <stop offset="0.922131" stop-opacity="0" />
              <stop offset="0.998723" />
              <stop offset="0.998823" />
            </linearGradient>
            <linearGradient
              id="switch_paint4_linear_10962_94683"
              x1="3.94961"
              y1="11.0713"
              x2="3.94961"
              y2="14.2053"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="1" stop-color="white" stop-opacity="0.49" />
            </linearGradient>
            <linearGradient
              id="switch_paint5_linear_10962_94683"
              x1="7.98257"
              y1="11.0713"
              x2="7.98257"
              y2="14.2053"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="white" stop-opacity="0.49" />
            </linearGradient>
            <linearGradient
              id="switch_paint6_linear_10962_94683"
              x1="17.595"
              y1="11.1798"
              x2="17.5824"
              y2="14.112"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.119491" stop-color="#8A8A8A" />
              <stop offset="0.882669" stop-color="#626262" />
              <stop offset="1" stop-color="#2E2D2D" />
            </linearGradient>
            <linearGradient
              id="switch_paint7_linear_10962_94683"
              x1="16.1094"
              y1="12.5925"
              x2="19.1604"
              y2="12.5786"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop
                offset="0.103943"
                stop-color="#555555"
                stop-opacity="0.917116"
              />
              <stop
                offset="0.858314"
                stop-color="#535353"
                stop-opacity="0.0974099"
              />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="switch_paint8_linear_10962_94683"
              x1="17.6137"
              y1="11.0713"
              x2="17.6137"
              y2="14.2053"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="white" stop-opacity="0.49" />
            </linearGradient>
            <linearGradient
              id="switch_paint9_linear_10962_94683"
              x1="7.9639"
              y1="6.75596"
              x2="7.95126"
              y2="9.68815"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.119491" stop-color="#8A8A8A" />
              <stop offset="0.882669" stop-color="#626262" />
              <stop offset="1" stop-color="#2E2D2D" />
            </linearGradient>
            <linearGradient
              id="switch_paint10_linear_10962_94683"
              x1="6.47829"
              y1="8.16867"
              x2="9.52931"
              y2="8.15476"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop
                offset="0.103943"
                stop-color="#555555"
                stop-opacity="0.917116"
              />
              <stop
                offset="0.858314"
                stop-color="#535353"
                stop-opacity="0.0974099"
              />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="switch_paint11_linear_10962_94683"
              x1="7.98257"
              y1="6.64746"
              x2="7.98257"
              y2="9.78146"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="white" stop-opacity="0.49" />
            </linearGradient>
            <linearGradient
              id="switch_paint12_linear_10962_94683"
              x1="17.595"
              y1="6.75596"
              x2="17.5824"
              y2="9.68815"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.119491" stop-color="#8A8A8A" />
              <stop offset="0.882669" stop-color="#626262" />
              <stop offset="1" stop-color="#2E2D2D" />
            </linearGradient>
            <linearGradient
              id="switch_paint13_linear_10962_94683"
              x1="16.1094"
              y1="8.16867"
              x2="19.1604"
              y2="8.15476"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop
                offset="0.103943"
                stop-color="#555555"
                stop-opacity="0.917116"
              />
              <stop
                offset="0.858314"
                stop-color="#535353"
                stop-opacity="0.0974099"
              />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="switch_paint14_linear_10962_94683"
              x1="17.6137"
              y1="6.64746"
              x2="17.6137"
              y2="9.78146"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="white" stop-opacity="0.49" />
            </linearGradient>
            <linearGradient
              id="switch_paint15_linear_10962_94683"
              x1="3.9307"
              y1="6.75596"
              x2="3.91806"
              y2="9.68815"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.119491" stop-color="#8A8A8A" />
              <stop offset="0.882669" stop-color="#626262" />
              <stop offset="1" stop-color="#2E2D2D" />
            </linearGradient>
            <linearGradient
              id="switch_paint16_linear_10962_94683"
              x1="2.44509"
              y1="8.16867"
              x2="5.4961"
              y2="8.15476"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop
                offset="0.103943"
                stop-color="#555555"
                stop-opacity="0.917116"
              />
              <stop
                offset="0.858314"
                stop-color="#535353"
                stop-opacity="0.0974099"
              />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="switch_paint17_linear_10962_94683"
              x1="3.94937"
              y1="6.64746"
              x2="3.94937"
              y2="9.78146"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="white" stop-opacity="0.49" />
            </linearGradient>
            <clipPath id="clip0_10962_94683">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </SVGIconRender>
  );
};

export default Switch;
